import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../organisms/Modal'
import HelpContent from './HelpContent'

export const HelpModalTemplate = ({
  abTests,
  open,
  onClose,
  onForgotPasswordLinkClick,
  onReactivationLinkClick,
  onMagicLinkClick,
}) => (
  <Modal open={open} onClose={onClose} transitionTime={250}>
    <HelpContent
      abTests={abTests}
      onForgotPasswordLinkClick={onForgotPasswordLinkClick}
      onReactivationLinkClick={onReactivationLinkClick}
      onMagicLinkClick={onMagicLinkClick}
      onOptionClick={onClose}
    />
  </Modal>
)

HelpModalTemplate.propTypes = {
  abTests: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onForgotPasswordLinkClick: PropTypes.func,
  onReactivationLinkClick: PropTypes.func,
  onMagicLinkClick: PropTypes.func,
}
